import Api from '@/api/Api'
import store from '../store'

export default {

  async uploadImage (data) {
    let options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
    return store.dispatch('checkResponseApi', await Api().post('image/upload', data, options))
  },

  async deleteImage (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('image/delete', { data: data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/FileService.js